/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateVaultedInterrogatoryRequest
 */
export interface UpdateVaultedInterrogatoryRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateVaultedInterrogatoryRequest
     */
    title?: string | null;
}

export function UpdateVaultedInterrogatoryRequestFromJSON(json: any): UpdateVaultedInterrogatoryRequest {
    return UpdateVaultedInterrogatoryRequestFromJSONTyped(json, false);
}

export function UpdateVaultedInterrogatoryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateVaultedInterrogatoryRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : json['title'],
    };
}

export function UpdateVaultedInterrogatoryRequestToJSON(value?: UpdateVaultedInterrogatoryRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
    };
}


